export default __webpack_public_path__ + "static/media/return.ac46259f.svg";